import { Box, Typography, Container } from "@mui/material";

const About = () => {
  return (
    <Container id="about" maxWidth="lg" sx={{ py: 12 }}>
      {/* First Paragraph */}
      <Box sx={{ mb: 6, textAlign: "center" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "28px", md: "36px" },
            lineHeight: { xs: "40px", md: "50px" },
            color: "#A9A7A7",
            fontWeight: { xs: 550, md: 550 },
            fontFamily: "Elza, sans-serif",
          }}
        >
          Yuva Changemakers is a{" "}
          <Box
            component="span"
            sx={{ position: "relative", display: "inline" }}
          >
            <Box
              component="img"
              src="/assets/lineone.png"
              alt=""
              sx={{
                position: "absolute",
                top: "-12px",
                top: { xs: "-8px", md: "-21px" },
                left: { xs: "-6px", md: "-10px" },
                width: { xs: "12px", md: "20px" },
                height: { xs: "40px", md: "63px" },
              }}
            />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "28px", md: "36px" },
                backgroundColor: "#8619CC2B",
                color: "#333333",
                px: 0.5,
                fontFamily: "Elza, sans-serif",
                fontWeight: 550,
              }}
            >
              1-year leadership fellowship programme for the youth of Himachal Pradesh
            </Typography>
          </Box>
          , who want to go beyond talking about change and actively create
          it. Through a hands-on, learning-by-doing approach, the{" "}
          <Box
            component="span"
            sx={{ position: "relative", display: "inline" }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "28px", md: "36px" },
                backgroundColor: "#8619CC2B",

                lineHeight: { xs: "40px", md: "50px" },
                color: "#333333",
                px: 0.5,
                fontFamily: "Elza, sans-serif",
                fontWeight: 550,
              }}
            >
              program offers exposure to leadership, governance, and community
              engagement while tackling real-world challenges.
            </Typography>
            <Box
              component="img"
              src="/assets/linetwo.png"
              alt=""
              sx={{
                position: "absolute",

                bottom: { xs: "-8px", md: "-19px" },

                right: { xs: "-6px", md: "-10px" },

                width: { xs: "12px", md: "20px" },
                height: { xs: "40px", md: "60px" },
              }}
            />
          </Box>
        </Typography>
      </Box>

      {/* Second Paragraph */}
      <Box sx={{ textAlign: "center", mb: 20 }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "28px", md: "36px" },
            lineHeight: { xs: "40px", md: "50px" },
            color: "#A9A7A7",
            fontWeight: 400,
            fontFamily: "Elza, sans-serif",
          }}
        >
          Launched by Lok Sabha MP{" "}
          <Typography
            component="span"
            sx={{
              color: "#333333",
              fontSize: { xs: "28px", md: "36px", fontWeight: 600 },
              lineHeight: { xs: "40px", md: "50px" },
              fontFamily: "Elza, sans-serif",
            }}
          >
            Anurag Singh Thakur, Yuva Changemakers
          </Typography>{" "}
          aims to nurture socially aware , ethically grounded, and
          action-oriented youth leaders who are ready to{" "}
          <Typography
            component="span"
            sx={{
              color: "#333333",
              fontSize: { xs: "28px", md: "36px", fontWeight: 600 },
              lineHeight: { xs: "40px", md: "50px" },
              fontFamily: "Elza, sans-serif",
            }}
          >
            take responsibility and contribute meaningfully to community
            development and nation-building
          </Typography>
          .
        </Typography>
      </Box>

      {/* Philosophy Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: { xs: 2, md: 16 },
          mb: 6,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            gap: { xs: 3, md: 1.5 },
            mb: { xs: 3, md: 0 },
            minWidth: { md: "320px" },
          }}
        >
          <Box
            component="img"
            src="/assets/box.png"
            alt="Philosophy"
            sx={{
              xs: { width: "37px", height: "37px" },
              md: { width: "40px", height: "44px" },
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: "37px", md: "42px" },
              color: "#333333",
              fontWeight: 700,
              fontFamily: "Test Domaine Display, serif",
            }}
          >
            PHILOSOPHY
          </Typography>
        </Box>
        <Box sx={{ maxWidth: "640px" }}>
          <Typography
            sx={{
              fontSize: { xs: "26px", md: "36px" },
              fontWeight: 400,
              lineHeight: { xs: "1.2", md: "1.2" },
              fontFamily: "Elza, sans-serif",
              color: "#333333",
            }}
          >
            True leadership is{" "}
            <Typography
              component="span"
              sx={{
                color: "#333333",
                fontSize: { xs: "26px", md: "36px" },
                lineHeight: { xs: "1.2", md: "1.2" },
                fontWeight: 600,
                fontFamily: "Elza, sans-serif",
              }}
            >
              discovered
            </Typography>
            {", "}
            <Typography
              component="span"
              sx={{
                color: "#333333",
                fontSize: { xs: "26px", md: "36px" },
                lineHeight: { xs: "1.2", md: "1.2" },
                fontWeight: 600,
                fontFamily: "Elza, sans-serif",
              }}
            >
              tested
            </Typography>
            {", and "}
            <Typography
              component="span"
              sx={{
                color: "#333333",
                fontSize: { xs: "26px", md: "36px" },
                lineHeight: { xs: "1.2", md: "1.2" },
                fontWeight: 600,
                fontFamily: "Elza, sans-serif",
              }}
            >
              nurtured
            </Typography>{" "}
            through community service, discipline, and intellectual debate.
          </Typography>
        </Box>
      </Box>

      {/* Divider Line */}
      <Box sx={{ display: "flex", justifyContent: "center", my: 12 }}>
        <Box
          component="img"
          src="/assets/divider.svg"
          alt=""
          sx={{
            width: { xs: "90%", md: "100%" },
            maxWidth: "536px",
            height: "auto",
          }}
        />
      </Box>

      {/* Vision Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: { xs: 2, md: 17.5 },

          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: { xs: 3, md: 0 },
            minWidth: { md: "320px" },
          }}
        >
          <Box
            component="img"
            src="/assets/eye.png"
            alt="Vision"
            sx={{
              xs: { width: "37px", height: "37px" },
              md: { width: "56px", height: "48px" },
            }}
          />
          <Typography
            className="font-domaine-bold"
            sx={{
              fontSize: { xs: "37px", md: "42px" },
              color: "#333333",
              fontWeight: 700,
              fontFamily: "Test Domaine Display, serif",
            }}
          >
            VISION
          </Typography>
        </Box>
        <Box sx={{ maxWidth: "640px" }}>
          <Typography
            sx={{
              lineHeight: { xs: "1.2", md: "1.2" },
              fontWeight: 400,
              fontSize: { xs: "28px", md: "36px" },
              fontFamily: "Elza, sans-serif",
              color: "#333333",
            }}
          >
            To{" "}
            <Typography
              component="span"
              sx={{
                color: "#333333",
                fontFamily: "Elza, sans-serif",
                fontWeight: 600,
                fontSize: { xs: "28px", md: "36px" },
                lineHeight: { xs: "1.2", md: "1.2" },
              }}
            >
              identify, nurture, and empower a new generation
            </Typography>{" "}
            of young leaders in Himachal Pradesh who can{" "}
            <Typography
              component="span"
              sx={{
                color: "#333333",
                fontSize: { xs: "28px", md: "36px" },
                fontWeight: 600,
                fontFamily: "Elza, sans-serif",
                lineHeight: { xs: "1.2", md: "1.2" },
              }}
            >
              lead communities
            </Typography>
            , drive impactful projects, and shape the political and
            developmental discourse of the state.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default About;
